import { Typography } from '@mui/material';
import Badge from '@mui/material/Badge';
import { keyframes } from '@mui/system';
import { useState, useEffect } from 'react';
import { WarningLite } from './WarningLite';

export const getColor = (value) => {
  let color = 'rgba(243, 152, 0, 1)';
  if (value == 'Accepted') {
    color = 'rgba(16, 211, 94, 1)';
  }
  if (value == 'Rejected') {
    color = 'rgba(249, 57, 57, 1)';
  }
  if (value == 'Pending') {
    color = 'orange';
  }
  if (value == 'Stage 2') {
    color = 'green';
  }
  if (value == 'Vendor Notified') {
    color = 'rgba(108, 42, 210, 1)';
  }
  if (value == 'Buyer Notified') {
    color = 'rgba(11, 168, 218, 1)';
  }
  if (value == 'Counter Offer') {
    color = 'rgba(255, 0, 255, 1)';
  }

  if (value == 'Private Offer') {
    color = '#4CA4D6';
  }
  return color;
};
const blink = keyframes`
  from { opacity: 1;}
  to { opacity: 0.3;}
`;
let blinkAnimation = {
  '& .MuiBadge-badge': {
    zIndex: '0',
    color: 'white',
    backgroundColor: '#2FCDFF',
    fontFamily: 'poppins',
    padding: '10px',
    right: '5px',
    borderRadius: '20px',
    padding: '2px 6px 2px 6px',
  },
};
let newText = {
  '& .MuiBadge-badge': {
    zIndex: '0',
    color: 'white',
    backgroundColor: '#2FCDFF',
    fontFamily: 'poppins',
    borderRadius: '20px',
    width: '1px',
    height: '15px',
    minWidth: '15px',
    marginTop: '1px',
  },
};
export default function BadgeButton({
  offerStatus,
  offerStatusVendor,
  isnew,
  Vendorpadding,
  row,
  manageOffer,
  StageTwo,
  matchesxs,
  matchessm,
  offerStatusCode,
}) {
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const userType = userDetail?.primaryUserType;
  const [isNewState, setIsNewState] = useState(isnew);
  const [index, setIndex] = useState(true);
  useEffect(() => {
    if (isNewState != isnew) setIsNewState(isnew);
    if (StageTwo || manageOffer || isnew == 0) return;
    const timer = setTimeout(() => {
      setIndex(false);
    }, 15000);

    return () => clearTimeout(timer);
  }, [StageTwo, manageOffer, isnew]);

  const getBadgeContent = () => {
    if (manageOffer || isNewState == 0) {
      return '';
    }
    if (StageTwo) {
      return '';
    }
    if (isNewState == 1) {
      if (index) {
        return 'New';
      }
      if (userType === 'Vendor') {
        return '';
      }
      if (
        row?.buyerOfferDetails?.isStageTwo === 0 &&
        offerStatus == 'Offer Received' &&
        row?.buyerDetails?.noOfOffers > 1
      ) {
        return row?.buyerOfferDetails?.unhandledOfferCount;
      }

      if (
        row?.buyerOfferDetails?.isStageTwo == 1 &&
        offerStatus == 'Offer Received' &&
        row?.buyerDetails?.stage2NoOfOffers > 1
      ) {
        return row?.buyerDetails?.stage2NoOfOffers;
      }
      return '';
    }
    return '';
  };

  return (
    <Badge
      badgeContent={
        manageOffer ||
        StageTwo ||
        isnew == 0 ||
        offerStatusCode == 'BuyerAccPrivate001'
          ? null
          : getBadgeContent()
      }
      sx={{
        ...(index &&
        isNewState == 1 &&
        !manageOffer &&
        !StageTwo &&
        offerStatusCode != 'BuyerAccPrivate001'
          ? blinkAnimation
          : {}),
        '& .MuiBadge-badge': {
          display:
            isNewState == 0 ||
            manageOffer ||
            StageTwo ||
            offerStatusCode == 'BuyerAccPrivate001'
              ? 'none'
              : 'inline-flex',
          fontSize: '8px',
          background: '#2FCDFF',
          fontFamily: 'poppins',
          color: 'white',
          transform: !index && 'scale(0.9)',
          top: !index && '-30%',
          right: !index && '-3%',
          zIndex: '0',
        },
      }}
      variant="standard"
    >
      <Typography
        sx={{
          padding: '3px 10px',
          border: `1px solid ${getColor(offerStatus)}`,
          borderRadius: '17px',
          width:
            StageTwo && matchesxs ? '100px' : matchessm ? '125px' : '135px',
          flexWrap: 'nowrap',
          whiteSpace: 'nowrap',
          fontFamily: 'Poppins !important',
          fontStyle: 'normal !important',
          fontWeight: '300 !important',
          fontSize:
            StageTwo && matchesxs ? '8px !important' : '12px !important',
          color: getColor(offerStatus),
          justifyContent: 'center',
          alignItems: 'center',
          display: 'flex',
          gap: 0.5,
        }}
      >
        <WarningLite color={getColor(offerStatus)} />
        {offerStatus}
      </Typography>
    </Badge>
  );
}
